import React, { FC } from 'react'
import {
  Button,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { useT, UT } from '@transifex/react'
import VendNumber from 'vend-number'
import { useVdCurrencyFilter } from '../../../../../../../ng-compat/hooks'

interface OverRefundPromptProps {
  refundFullAmount: () => void
  refundOriginalAmount: () => void
  rptName: string
  refundableAmount: VendNumber
}

export const OverRefundPrompt: FC<OverRefundPromptProps> = ({
  refundFullAmount,
  refundOriginalAmount,
  rptName,
  refundableAmount,
}) => {
  const t = useT()
  const vdCurrencyFilter = useVdCurrencyFilter()
  return (
    <>
      <ModalHeader>
        {t(
          'The refund amount is more than the original amount paid by {rptName} on this sale.',
          {
            rptName,
            _context:
              'The Lightspeed Payments refund prompt header informs the user that the refund request exceeds the balance on the original payment.',
          }
        )}
      </ModalHeader>
      <ModalContent>
        <p className="vd-p" data-testid="server-driven-over-refund-message">
          <UT
            _inline
            _str={`The original amount paid by {rptName} on this sale is <strong>{refundableAmount}</strong>. You can refund this original amount to the card that made the original payment, then refund the balance with another payment type. Alternatively you can refund the full amount unlinked to the original payment to any card present.`}
            rptName={rptName}
            refundableAmount={vdCurrencyFilter(
              refundableAmount.abs().toNumber()
            )}
            _context={`The Lightspeed Payments refund prompt message informs the user that the refund request exceeds the balance on the original payment.`}
          />
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            data-track="refund-full-amount-over-refund-modal"
            variant="supplementary"
            onClick={refundFullAmount}
          >
            {t('Refund Full Amount', {
              _context: 'Button to proceed with the full amount.',
            })}
          </Button>
          <Button
            data-track="refund-original-amount-over-refund-modal"
            variant="go"
            onClick={refundOriginalAmount}
          >
            {t('Refund Original Amount', {
              _context: 'Button to proceed with the original amount',
            })}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
